import "./credits.js";

const ensureComponent = () => {
  if (!document.querySelector("near-credits")) {
    const credits = document.createElement("near-credits");
    document.body.appendChild(credits);
  }
};

document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", ensureComponent, { once: true })
  : ensureComponent();

export const createCreditsComponent = (options = {}) => {
  const component = document.createElement("near-credits");
  Object.assign(component, options);
  return component;
};
